import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../context/I18nContext';
import { useAuth } from '../../context/AuthContext';
import { authColors, clickableLinks, neutralColors, shadows } from '../../styles/colors';
import Logo from '../common/Logo';
import PublicMobileMenu from './PublicMobileMenu';
import { Menu } from 'lucide-react';
import { trackUmamiEvent } from '../../utils/umami';

const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

const PublicHeader: React.FC = () => {
  const { t } = useI18n();
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <header className={`bg-white/80 backdrop-blur-md ${shadows.subtle} fixed top-0 left-0 right-0 z-50 border-b ${neutralColors.grayBorder}`}>
        <nav className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-10 xl:px-12">
          <div className="flex items-center h-16">
            {/* Mobile Menu Button - Left */}
            <div className="lg:hidden flex-shrink-0">
              <button
                onClick={() => setMenuOpen(!menuOpen)}
                className={`p-2 rounded-md ${neutralColors.grayTextLight} hover:text-gray-900 hover:${neutralColors.gray100} focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500`}
                aria-label="Toggle menu"
              >
                <Menu className="h-6 w-6" />
              </button>
            </div>
            {/* Logo - Center */}
            <div className="flex-1 flex justify-center lg:justify-start">
              <Logo />
            </div>
            {/* Desktop Navigation - Right */}
            <div className="hidden lg:flex items-center space-x-2">
              <Link to="/" onClick={scrollToTop} className={`${clickableLinks} px-4 py-2 rounded-lg text-sm font-medium transition-all hover:bg-blue-50`}>
                {t('landing.home')}
              </Link>
              <Link to="/pricing" onClick={() => { scrollToTop(); trackUmamiEvent('pricing_click', { source: 'header' }); }} className={`${clickableLinks} px-4 py-2 rounded-lg text-sm font-medium transition-all hover:bg-blue-50`}>
                {t('landing.pricing')}
              </Link>
              <Link to="/blog" onClick={scrollToTop} className={`${clickableLinks} px-4 py-2 rounded-lg text-sm font-medium transition-all hover:bg-blue-50`}>
                {t('blog.nav')}
              </Link>
              <Link to="/contact" onClick={scrollToTop} className={`${clickableLinks} px-4 py-2 rounded-lg text-sm font-medium transition-all hover:bg-blue-50`}>
                {t('landing.contact')}
              </Link>
              {!user && (
                <Link to="/login" onClick={() => { scrollToTop(); trackUmamiEvent('sign_in_click', { source: 'header' }); }} className={`${clickableLinks} px-4 py-2 rounded-lg text-sm font-medium transition-all hover:bg-blue-50`}>
                  {t('landing.signIn')}
                </Link>
              )}
              <Link
                to={user ? '/app' : '/signup'}
                onClick={() => {
                  scrollToTop();
                  if (!user) trackUmamiEvent('signup_click', { source: 'header' });
                }}
                className={`${authColors.primaryGradient} text-white font-medium px-6 py-2 text-sm rounded-lg ${shadows.medium} hover:shadow-lg transition-all transform hover:scale-105 whitespace-nowrap`}
              >
                {user ? t('nav.dashboard') : t('landing.headerSignup')}
              </Link>
            </div>
            {/* Spacer for mobile to keep logo centered */}
            <div className="lg:hidden w-10 flex-shrink-0"></div>
          </div>
        </nav>
      </header>
      {/* Mobile Menu */}
      <PublicMobileMenu isOpen={menuOpen} onClose={closeMenu} />
    </>
  );
};

export default PublicHeader;



